<div class="column" [ngClass]="{'active': isFocused, 'accepted': isAccepted, 'error': isError,'error-bcg': isError && isEmpty, 'suf': isSuffix}">
    <div class="row" [class.small]="small">
        <input #inputNumber placeholder="Insert Number" [(ngModel)]="model" [class.disabled]="isDisabled" (keydown.enter)="enterClicked.emit()" inputmode="numeric" type="text" [formControl]="val" pattern="{{pattern}}" (keydown)="arrowStep($event)" (focus)="onFocus()" (blur)="onBlur()" [min]="min" [max]="max">
        <span *ngIf="isSuffix" class="sufix"><span class="suf">{{suffix}}</span></span>
    </div>
    <!-- <div *ngIf="isError" class="container ">
        <span>{{errorText}}</span>
    </div> -->
</div>